
import { BaseModal } from "@/react/components/editors/base/BaseModal";
import { BaseModalBody } from "@/react/components/editors/base/BaseModalBody";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/modern/components/ui/tabs";
import { GeneralTab } from "./tabs/GeneralTab";
import { ContactTab } from "./tabs/ContactTab";
import { UserEditorProvider, useUserEditorContext } from "./context/UserEditorContext";
import { User } from "@/bryntum-lib/models/User";

export interface UserEditorProps {
  record: {
    user: User;
    selectTabByTypeOnOpen?: string;
    [key: string]: any;
  };
  onClose: () => void;
  editorInstance?: {
    className?: string;
    [key: string]: unknown;
  };
  context?: any;
}

const UserEditorContent = () => {
  const { userRecord, onClose, activeTab, setActiveTab, editorInstance } = useUserEditorContext();

  const isPhantom = userRecord?.isPhantom ?? true;

  return (
    <BaseModal
      record={userRecord}
      onClose={onClose}
      title={userRecord?.name || "New User"}
      description=""
      editorInstance={editorInstance}
      hideMenu={true}
      size={{
        width: "60em",
        height: "min(100vh, 800px)",
        maxHeight: "100vh",
        maxWidth: "100vw",
        minWidth: "30em",
        minHeight: "600px"
      }}
      modal={false}
      version={undefined}
      swivuAssistanceConfig={undefined}
      headerIconCls=""
    >
      <BaseModalBody>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="flex flex-col flex-1 h-full">
          <TabsList className="mb-4 w-full">
            <TabsTrigger value="general" className="flex-1">
              General
            </TabsTrigger>
            <TabsTrigger value="contact" className="flex-1" disabled={isPhantom}>
              <i className="fa-regular fa-user w-4 h-4" />
              Contacts
            </TabsTrigger>
          </TabsList>

          <TabsContent value="general" className="flex-1 overflow-hidden">
            <GeneralTab />
          </TabsContent>

          <TabsContent value="contact" className="flex-1 overflow-hidden">
            <ContactTab />
          </TabsContent>
        </Tabs>
      </BaseModalBody>
    </BaseModal>
  );
};

export const UserEditor = ({ record, onClose, editorInstance }: UserEditorProps) => {
  return (
    <UserEditorProvider userRecord={record.user} onClose={onClose} record={record} editorInstance={editorInstance}>
      <UserEditorContent />
    </UserEditorProvider>
  );
};
